// // import React, { useState } from "react";

// // const payouts = [
// //   {
// //     payoutId: "PAY001",
// //     seller: "Fresh Mart",
// //     subadmin: "Kochi Subadmin",
// //     orderId: "ORD001",
// //     orderTotal: 1200,
// //     commission: 120,
// //     payableAmount: 1080,
// //     paymentMode: "ONLINE",
// //     payoutStatus: "PAID",
// //     payoutDate: "2025-12-16",
// //   },
// //   {
// //     payoutId: "PAY002",
// //     seller: "Veg Basket",
// //     subadmin: "Trivandrum Subadmin",
// //     orderId: "ORD003",
// //     orderTotal: 1500,
// //     commission: 180,
// //     payableAmount: 1320,
// //     paymentMode: "ONLINE",
// //     payoutStatus: "UNPAID",
// //     payoutDate: null,
// //   },
// // ];

// // const AdminSellerPayout = () => {
// //   const [status, setStatus] = useState("ALL");

// //   const filtered = payouts.filter(p =>
// //     status === "ALL" ? true : p.payoutStatus === status
// //   );

// //   const totalPayable = filtered.reduce(
// //     (sum, p) => sum + p.payableAmount,
// //     0
// //   );

// //   const paid = filtered
// //     .filter(p => p.payoutStatus === "PAID")
// //     .reduce((sum, p) => sum + p.payableAmount, 0);

// //   const pending = totalPayable - paid;

// //   return (
// //     <div className="p-6 space-y-6">
// //       {/* Header */}
// //       <div>
// //         <h2 className="text-xl font-bold text-gray-800">Seller Payouts</h2>
// //         <p className="text-sm text-gray-500">
// //           Money to be transferred to sellers (ONLINE orders only)
// //         </p>
// //       </div>

// //       {/* Filters */}
// //       <div className="flex gap-4 bg-white p-4 rounded shadow">
// //         <select
// //           value={status}
// //           onChange={e => setStatus(e.target.value)}
// //           className="border rounded px-3 py-2 focus:ring-2 focus:ring-green-400"
// //         >
// //           <option value="ALL">All Status</option>
// //           <option value="PAID">Paid</option>
// //           <option value="UNPAID">Unpaid</option>
// //         </select>
// //       </div>

// //       {/* Summary */}
// //       <div className="grid grid-cols-3 gap-4">
// //         <Summary title="Total Payable" value={totalPayable} />
// //         <Summary title="Paid to Sellers" value={paid} />
// //         <Summary title="Pending Payout" value={pending} />
// //       </div>

// //       {/* Table */}
// //       <div className="bg-white rounded shadow overflow-x-auto">
// //         <table className="w-full text-sm">
// //           <thead className="bg-green-50 text-left">
// //             <tr>
// //               <th className="p-3">Payout ID</th>
// //               <th className="p-3">Seller</th>
// //               <th className="p-3">Subadmin</th>
// //               <th className="p-3">Order</th>
// //               <th className="p-3">Payable</th>
// //               <th className="p-3">Status</th>
// //               <th className="p-3">Action</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {filtered.map(p => (
// //               <tr key={p.payoutId} className="border-t">
// //                 <td className="p-3">{p.payoutId}</td>
// //                 <td className="p-3">{p.seller}</td>
// //                 <td className="p-3">{p.subadmin}</td>
// //                 <td className="p-3">{p.orderId}</td>
// //                 <td className="p-3 font-semibold text-green-700">
// //                   ₹{p.payableAmount}
// //                 </td>
// //                 <td className="p-3">
// //                   <span
// //                     className={`px-2 py-1 rounded text-xs font-medium ${
// //                       p.payoutStatus === "PAID"
// //                         ? "bg-green-100 text-green-700"
// //                         : "bg-yellow-100 text-yellow-700"
// //                     }`}
// //                   >
// //                     {p.payoutStatus}
// //                   </span>
// //                 </td>
// //                 <td className="p-3">
// //                   {p.payoutStatus === "UNPAID" ? (
// //                     <button className="text-xs bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700">
// //                       Mark as Paid
// //                     </button>
// //                   ) : (
// //                     <span className="text-xs text-gray-400">Completed</span>
// //                   )}
// //                 </td>
// //               </tr>
// //             ))}
// //           </tbody>
// //         </table>
// //       </div>
// //     </div>
// //   );
// // };

// // const Summary = ({ title, value }) => (
// //   <div className="bg-white p-4 rounded shadow">
// //     <p className="text-sm text-gray-500">{title}</p>
// //     <p className="text-xl font-bold text-green-700">₹{value}</p>
// //   </div>
// // );

// // export default AdminSellerPayout;


// // import React from "react";

// // const sellers = [
// //   {
// //     sellerId: "SELL001",
// //     sellerName: "Fresh Mart",
// //     totalEarned: 42000,
// //     availableBalance: 12000,
// //     serviceFeePending: 3000, // COD commission
    
// //   },
// //   {
// //     sellerId: "SELL002",
// //     sellerName: "Veg Basket",
// //     totalEarned: 28000,
// //     availableBalance: 0,
// //     serviceFeePending: 4500,
// //   },
// //   {
// //     sellerId: "SELL003",
// //     sellerName: "Daily Needs",
// //     totalEarned: 35000,
// //     availableBalance: 9000,
// //     serviceFeePending: 0,
// //   },
// // ];

// // const SellerPayouts = () => {
// //   return (
// //     <div className="p-6 space-y-6">
// //       {/* Summary */}
// //       <div className="grid grid-cols-4 gap-4">
// //         <SummaryCard title="Total Sellers" value={sellers.length} />
// //         <SummaryCard
// //           title="Total Payable"
// //           value={`₹${sellers.reduce(
// //             (s, x) => s + x.availableBalance,
// //             0
// //           )}`}
// //         />
// //         <SummaryCard
// //           title="Service Fee Pending (COD)"
// //           value={`₹${sellers.reduce(
// //             (s, x) => s + x.serviceFeePending,
// //             0
// //           )}`}
// //           danger
// //         />
// //       </div>

// //       {/* Table */}
// //       <div className="bg-white rounded-lg shadow overflow-x-auto">
// //         <table className="w-full text-sm">
// //           <thead className="bg-green-50 text-left">
// //             <tr>
// //               <th className="p-3">Seller</th>
// //               <th className="p-3">Total Earned</th>
// //               <th className="p-3">Available Balance</th>
// //               <th className="p-3">Service Fee (COD)</th>
// //               <th className="p-3">Net Payable</th>
// //               <th className="p-3">Action</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {sellers.map(s => {
// //               const netPayable =
// //                 s.availableBalance - s.serviceFeePending;

// //               return (
// //                 <tr key={s.sellerId} className="border-t">
// //                   <td className="p-3">
// //                     <p className="font-medium">{s.sellerName}</p>
// //                     <p className="text-xs text-gray-500">
// //                       {s.sellerId}
// //                     </p>
// //                   </td>
// //                   <td className="p-3">₹{s.totalEarned}</td>
// //                   <td className="p-3 text-green-700 font-semibold">
// //                     ₹{s.availableBalance}
// //                   </td>
// //                   <td className="p-3 text-red-600 font-semibold">
// //                     ₹{s.serviceFeePending}
// //                   </td>
// //                   <td
// //                     className={`p-3 font-bold ${
// //                       netPayable >= 0
// //                         ? "text-green-700"
// //                         : "text-red-600"
// //                     }`}
// //                   >
// //                     ₹{netPayable}
// //                   </td>
// //                   <td className="p-3">
// //                     {netPayable > 0 ? (
// //                       <button className="px-3 py-1 bg-green-600 text-white rounded text-xs">
// //                         Pay Seller
// //                       </button>
// //                     ) : s.serviceFeePending > 0 ? (
// //                       <button className="px-3 py-1 bg-red-500 text-white rounded text-xs">
// //                         Collect Fee
// //                       </button>
// //                     ) : (
// //                       <span className="text-xs text-gray-400">
// //                         Settled
// //                       </span>
// //                     )}
// //                   </td>
// //                 </tr>
// //               );
// //             })}
// //           </tbody>
// //         </table>
// //       </div>
// //     </div>
// //   );
// // };

// // const SummaryCard = ({ title, value, danger }) => (
// //   <div className="bg-white rounded-lg shadow p-4">
// //     <p className="text-sm text-gray-500">{title}</p>
// //     <p
// //       className={`text-xl font-bold ${
// //         danger ? "text-red-600" : "text-green-700"
// //       }`}
// //     >
// //       {value}
// //     </p>
// //   </div>
// // );

// // export default SellerPayouts;


// import React, { useState } from "react";

// const sellers = [
//   {
//     sellerId: "SELL001",
//     sellerName: "Fresh Mart",
//     totalEarned: "₹42,000",
//     payableAmount: "₹12,000",
//     serviceFeeDue: "₹3,000",
//   },
//   {
//     sellerId: "SELL002",
//     sellerName: "Veg Basket",
//     totalEarned: "₹28,000",
//     payableAmount: "₹0",
//     serviceFeeDue: "₹4,500",
//   },
//   {
//     sellerId: "SELL003",
//     sellerName: "Daily Needs",
//     totalEarned: "₹35,000",
//     payableAmount: "₹9,000",
//     serviceFeeDue: "₹0",
//   },
// ];

// const SellerPayouts = () => {
//   const [modal, setModal] = useState(null);

//   return (
//     <div className="p-6 space-y-6">
//       {/* Summary (Dummy) */}
//       <div className="grid grid-cols-3 gap-4">
//         <SummaryCard title="Total Sellers" value="3" />
//         <SummaryCard title="Total Payable" value="₹21,000" />
//         <SummaryCard title="Service Fee Pending" value="₹7,500" danger />
//       </div>

//       {/* Table */}
//       <div className="bg-white rounded-lg shadow overflow-x-auto">
//         <table className="w-full text-sm">
//           <thead className="bg-green-50 text-left">
//             <tr>
//               <th className="p-3">Seller</th>
//               <th className="p-3">Total Earned</th>
//               <th className="p-3">Payable to Seller</th>
//               <th className="p-3">Service Fee Due</th>
//               <th className="p-3">Actions</th>
//             </tr>
//           </thead>

//           <tbody>
//             {sellers.map((s) => (
//               <tr key={s.sellerId} className="border-t">
//                 <td className="p-3">
//                   <p className="font-medium">{s.sellerName}</p>
//                   <p className="text-xs text-gray-500">{s.sellerId}</p>
//                 </td>

//                 <td className="p-3">{s.totalEarned}</td>
//                 <td className="p-3 text-green-700 font-semibold">
//                   {s.payableAmount}
//                 </td>
//                 <td className="p-3 text-red-600 font-semibold">
//                   {s.serviceFeeDue}
//                 </td>

//                 <td className="p-3 flex gap-2">
//                   <button
//                     onClick={() =>
//                       setModal({
//                         type: "PAY",
//                         sellerId: s.sellerId,
//                         amount: s.payableAmount,
//                       })
//                     }
//                     className="px-3 py-1 bg-green-600 text-white rounded text-xs"
//                   >
//                     Pay Seller
//                   </button>

//                   <button
//                     onClick={() =>
//                       setModal({
//                         type: "COLLECT",
//                         sellerId: s.sellerId,
//                         amount: s.serviceFeeDue,
//                       })
//                     }
//                     className="px-3 py-1 bg-red-600 text-white rounded text-xs"
//                   >
//                     Collect Fee
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {modal && (
//         <ActionModal
//           {...modal}
//           onClose={() => setModal(null)}
//         />
//       )}
//     </div>
//   );
// };

// const SummaryCard = ({ title, value, danger }) => (
//   <div className="bg-white rounded-lg shadow p-4">
//     <p className="text-sm text-gray-500">{title}</p>
//     <p
//       className={`text-xl font-bold ${
//         danger ? "text-red-600" : "text-green-700"
//       }`}
//     >
//       {value}
//     </p>
//   </div>
// );

// const ActionModal = ({ type, sellerId, amount, onClose }) => {
//   const isPay = type === "PAY";

//   const handleSubmit = () => {
//     console.log("DUMMY SUBMIT →", {
//       action: type,
//       sellerId,
//       amount,
//     });
//     onClose();
//   };

//   return (
//     <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
//       <div className="bg-white rounded-lg w-full max-w-sm p-6 space-y-4">
//         <h2 className="text-lg font-bold">
//           {isPay ? "Pay Seller" : "Collect Service Fee"}
//         </h2>

//         <div className="text-sm text-gray-700 space-y-1">
//           <p>Seller ID: <b>{sellerId}</b></p>
//           <p>Amount: <b>{amount}</b></p>
//         </div>

//         <div className="flex justify-end gap-2">
//           <button
//             onClick={onClose}
//             className="px-3 py-1 border rounded text-sm"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSubmit}
//             className={`px-4 py-1 text-white rounded text-sm ${
//               isPay ? "bg-green-600" : "bg-red-600"
//             }`}
//           >
//             Confirm
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SellerPayouts;

import React, { useEffect, useState } from "react";
import { SellersBalanceFetchApi } from "../../ApiCalls/Revenue";

/* ================= SELLER PAYOUTS ================= */

const SellerPayouts = () => {
  const [sellers, setSellers] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);

  /* ---------- FETCH SELLERS BALANCE ---------- */
  useEffect(() => {
  const fetchSellers = async () => {
    try {
      const response = await SellersBalanceFetchApi();
      console.log("SELLERS BALANCE RESPONSE", response);

      setSellers(response?.data || []);
      setSummary(response?.summary || null);

    } catch (error) {
      console.error("Failed to fetch sellers balance", error);
    } finally {
      setLoading(false);
    }
  };

  fetchSellers();
}, []);

  return (
    <div className="p-6 space-y-6">
      {/* ---------- SUMMARY ---------- */}
      {summary && (
        <div className="grid grid-cols-3 gap-4">
          <SummaryCard
            title="Total Sellers"
            value={summary.total_sellers}
          />
          <SummaryCard
            title="Total Payable to Sellers"
            value={`₹${summary.total_available_balance}`}
          />
          <SummaryCard
            title="Service Fee Pending"
            value={`₹${summary.total_cod_service_fee_due}`}
          />
        </div>
      )}

      {/* ---------- TABLE ---------- */}
      <div className="bg-white rounded-lg shadow overflow-x-auto">
        {loading ? (
          <p className="p-4 text-center text-gray-500">
            Loading sellers...
          </p>
        ) : sellers.length === 0 ? (
          <p className="p-4 text-center text-gray-500">
            No sellers found
          </p>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-green-50 text-left">
              <tr>
                <th className="p-3">Seller</th>
                <th className="p-3">Total Earned</th>
                <th className="p-3">Payable Amount</th>
                <th className="p-3">Service Fee Due</th>
                <th className="p-3">Date</th>
                <th className="p-3">Actions</th>
              </tr>
            </thead>

            <tbody>
              {sellers.map((s) => (
                <tr key={s.seller_id} className="border-t">
                  <td className="p-3">
                    <p className="font-medium">{s.seller_name}</p>
                    <p className="text-xs text-gray-500">
                      {s.seller_id}
                    </p>
                  </td>

                  <td className="p-3">₹{s.total_earned}</td>

                  <td className="p-3 text-green-700 font-semibold">
                    ₹{s.payable_amount}
                  </td>

                  <td className="p-3 text-red-600 font-semibold">
                    ₹{s.service_fee_due}
                  </td>

                  {/* DATE FROM BACKEND */}
                  <td className="p-3 text-gray-600">
                    {s.date
                      ? new Date(s.date).toLocaleDateString("en-IN")
                      : "-"}
                  </td>

                  <td className="p-3 flex gap-2">
                    <button
                      disabled={s.payable_amount <= 0}
                      onClick={() =>
                        setModal({
                          type: "PAY",
                          sellerId: s.seller_id,
                          amount: s.payable_amount,
                        })
                      }
                      className="px-3 py-1 bg-green-600 text-white rounded text-xs hover:bg-green-700 disabled:opacity-50"
                    >
                      Pay Seller
                    </button>

                    <button
                      disabled={s.service_fee_due <= 0}
                      onClick={() =>
                        setModal({
                          type: "COLLECT",
                          sellerId: s.seller_id,
                          amount: s.service_fee_due,
                        })
                      }
                      className="px-3 py-1 bg-red-600 text-white rounded text-xs hover:bg-red-700 disabled:opacity-50"
                    >
                      Collect Fee
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* ---------- MODAL ---------- */}
      {modal && (
        <ActionModal {...modal} onClose={() => setModal(null)} />
      )}
    </div>
  );
};

/* ================= SUMMARY CARD ================= */

const SummaryCard = ({ title, value }) => (
  <div className="bg-white rounded-lg shadow p-4">
    <p className="text-sm text-gray-500">{title}</p>
    <p className="text-xl font-bold text-green-700">
      {value}
    </p>
  </div>
);

/* ================= ACTION MODAL ================= */

const ActionModal = ({ type, sellerId, amount, onClose }) => {
  const [inputAmount, setInputAmount] = useState(amount);
  const isPay = type === "PAY";

  const handleSubmit = () => {
    console.log("SELLER ACTION →", {
      action: type,
      sellerId,
      amount: inputAmount,
    });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-full max-w-sm p-6 space-y-4">
        <h2 className="text-lg font-bold text-green-700">
          {isPay ? "Pay Seller" : "Collect Service Fee"}
        </h2>

        <div className="space-y-3 text-sm">
          <div>
            <label className="block text-xs text-gray-500 mb-1">
              Seller ID
            </label>
            <input
              value={sellerId}
              disabled
              className="w-full border rounded px-3 py-2 bg-gray-100"
            />
          </div>

          <div>
            <label className="block text-xs text-gray-500 mb-1">
              Amount
            </label>
            <input
              type="number"
              value={inputAmount}
              onChange={(e) => setInputAmount(e.target.value)}
              className="w-full border rounded px-3 py-2 focus:ring-2 focus:ring-green-500"
            />
          </div>
        </div>

        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-3 py-1 border rounded text-sm"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-1 bg-green-600 text-white rounded text-sm hover:bg-green-700"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default SellerPayouts;
